import {Logger} from '@milestoneslabs/milestones-js-engine';

export default {
    filterResources: ({commit}, filters) => {
        // TODO: filter here
        // update the resources from state using mutations

        console.log('Filtering...');
        console.log(filters);
    },

    sendFeedback: ({getters}, isHelpful) => {
        console.log('Sending feedback: ' + isHelpful);
    },
};
